import {flavorDescriptions, colors, strokeWidth} from '../constants';

import {
  createPoint,
  buildGeometryInstance,
  isSameCoordinatePair,
  getLayerForFlavoredEntityType,
  handleAddCorrectnessIcon,
  hasCoords
} from './entities.utils';

const line = {
  /**
   * @example
   * const entity = {
   *   type: 'line',
   *   elements: {
   *     points: [
   *       [0, 0],
   *       [4, 1]
   *     ]
   *   },
   *   flavor: 'studentGuess'
   * };
   */

  create({board, entity, onClick}) {
    const {
      flavor,
      elements: {points}
    } = entity;

    const linePoints = points.map((coords) => createPoint({board, coords, flavor}));

    const correctnessIcon = handleAddCorrectnessIcon({board, flavor, coords: points[0]});

    const {color} = flavorDescriptions[flavor];

    const line = board.create('line', linePoints, {
      strokeWidth,
      highlightStrokeWidth: strokeWidth,
      firstArrow: true,
      lastArrow: true,
      strokeColor: color,
      highlightStrokeColor: color,
      touchFirstPoint: true,
      touchLastPoint: true,
      layer: getLayerForFlavoredEntityType('line', flavor),
      tabindex: null
    });

    return buildGeometryInstance({
      board,
      entity,
      geometryElement: line,
      constituentElements: [...linePoints, line],
      onClick,
      correctnessIcon
    });
  },
  createPartial({board, partialInstance, coords, flavor}) {
    if (!partialInstance) {
      return {
        entity: {
          type: 'line',
          elements: {
            points: []
          },
          flavor
        },
        geometryElements: [],
        done: false,
        preview: null,
        remove() {
          return null;
        }
      };
    }

    const isValid = !hasCoords(partialInstance.entity.elements, coords);

    if (!isValid) return null;

    const points = [...partialInstance.entity.elements.points, coords];
    const nextPoint = createPoint({board, coords, flavor});
    const geometryElements = [...partialInstance.geometryElements, nextPoint];

    return {
      entity: {
        type: 'line',
        elements: {
          points
        },
        flavor
      },
      geometryElements,
      done: points.length === 2,
      instructions: 'Complete the line by placing a second point.',
      handleCursorMove(cursorCoords) {
        if (board.elementsByName.previewLine) {
          board.removeAncestors(board.elementsByName.previewLine);
        }

        if (!coords || !cursorCoords || isSameCoordinatePair(coords, cursorCoords)) {
          return;
        }

        board.create('line', [coords, cursorCoords], {
          name: 'previewLine',
          strokeWidth,
          highlightStrokeWidth: strokeWidth,
          strokeColor: colors.preview,
          highlightStrokeColor: colors.preview,
          dash: 3,
          firstArrow: true,
          lastArrow: true,
          touchFirstPoint: true,
          touchLastPoint: true,
          tabindex: null
        });
      },
      remove() {
        geometryElements.forEach((element) => board.removeAncestors(element));
        return null;
      }
    };
  }
};

export default line;
